<form [formGroup]="formGroup" class="d-flex flex-wrap align-items-end gap-3" (ngSubmit)="submit()">
  <label class="filter-field d-flex flex-column gap-1" for="filter-search">
    <span class="av-meta">{{ 'backoffice.organizations.filters.search' | translate }}</span>
    <input
      id="filter-search"
      type="search"
      class="av-field"
      formControlName="search"
      autocomplete="off"
      [attr.placeholder]="'backoffice.organizations.filters.search_hint' | translate"
    />
  </label>

  <label class="filter-field d-flex flex-column gap-1" for="filter-status">
    <span class="av-meta">{{ 'backoffice.organizations.filters.status' | translate }}</span>
    <select id="filter-status" class="av-field" formControlName="status">
      <option value="">{{ 'backoffice.organizations.filters.any_status' | translate }}</option>
      @for (status of statusOptions; track status) {
        <option [value]="status">{{ statusLabelKeys[status] | translate }}</option>
      }
    </select>
  </label>

  <label class="filter-field d-flex flex-column gap-1" for="filter-plan">
    <span class="av-meta">{{ 'backoffice.organizations.filters.plan' | translate }}</span>
    <select id="filter-plan" class="av-field" formControlName="plan_id">
      <option value="">{{ 'backoffice.organizations.filters.any_plan' | translate }}</option>
      @for (plan of plans(); track plan.id) {
        <option [value]="plan.id">{{ plan.displayName }} · v{{ plan.version }}</option>
      }
    </select>
  </label>

  <div class="d-flex align-items-center gap-2">
    <button type="submit" class="av-btn av-btn-primary" [disabled]="disabled()">
      <mat-icon aria-hidden="true">filter_alt</mat-icon>
      {{ 'backoffice.common.actions.apply' | translate }}
    </button>

    <button type="button" class="av-btn" [disabled]="disabled()" (click)="reset()">
      <mat-icon aria-hidden="true">filter_alt_off</mat-icon>
      {{ 'backoffice.common.actions.clear' | translate }}
    </button>
  </div>
</form>
